<apex-user-card
  [user]="user"
  [client]="client"
  [clientUrl]="clientUrl"
  [subtitle]="subtitle"
  [subtitleIcon]="subtitleIcon"
  [close]="makeClose()">
</apex-user-card>
